// @ts-nocheck
import { Component } from 'react';
import { ApplyPluginsType } from 'umi';
import dva from 'dva';
// @ts-ignore
import createLoading from '/data/landun/workspace/p-886b67fca2dd4cca8e715cc19519f511/src/node_modules/dva-loading/dist/index.esm.js';
import { plugin, history } from '../core/umiExports';
import ModelBenchmark0 from '/data/landun/workspace/p-886b67fca2dd4cca8e715cc19519f511/src/src/pages/benchmark/models/benchmark.ts';
import ModelDashboard1 from '/data/landun/workspace/p-886b67fca2dd4cca8e715cc19519f511/src/src/pages/dashboard/models/dashboard.ts';
import ModelDashboardSetting2 from '/data/landun/workspace/p-886b67fca2dd4cca8e715cc19519f511/src/src/pages/dashboard/models/dashboardSetting.ts';
import ModelEngagement3 from '/data/landun/workspace/p-886b67fca2dd4cca8e715cc19519f511/src/src/pages/dashboard/models/engagement.ts';
import ModelMonetization4 from '/data/landun/workspace/p-886b67fca2dd4cca8e715cc19519f511/src/src/pages/dashboard/models/monetization.ts';
import ModelOverview5 from '/data/landun/workspace/p-886b67fca2dd4cca8e715cc19519f511/src/src/pages/dashboard/models/overview.ts';
import ModelRangePikerLeft6 from '/data/landun/workspace/p-886b67fca2dd4cca8e715cc19519f511/src/src/pages/dashboard/models/rangePikerLeft.ts';
import ModelRealtime7 from '/data/landun/workspace/p-886b67fca2dd4cca8e715cc19519f511/src/src/pages/dashboard/models/realtime.ts';
import ModelCustomDashboardTs8 from '/data/landun/workspace/p-886b67fca2dd4cca8e715cc19519f511/src/src/pages/datalab/models/customDashboard.ts.ts';
import ModelDatalab9 from '/data/landun/workspace/p-886b67fca2dd4cca8e715cc19519f511/src/src/pages/datalab/models/datalab.ts';
import ModelExploreAnalysisGames10 from '/data/landun/workspace/p-886b67fca2dd4cca8e715cc19519f511/src/src/pages/datalab/models/exploreAnalysisGames.ts';
import ModelPrivilegesConfig11 from '/data/landun/workspace/p-886b67fca2dd4cca8e715cc19519f511/src/src/pages/datalab/models/privilegesConfig.ts';
import ModelCollapseableLogoList12 from '/data/landun/workspace/p-886b67fca2dd4cca8e715cc19519f511/src/src/pages/globalpedia/models/collapseableLogoList.ts';
import ModelDetailProgressTag13 from '/data/landun/workspace/p-886b67fca2dd4cca8e715cc19519f511/src/src/pages/globalpedia/models/detailProgressTag.ts';
import ModelGameDetailTabData14 from '/data/landun/workspace/p-886b67fca2dd4cca8e715cc19519f511/src/src/pages/globalpedia/models/gameDetailTabData.ts';
import ModelGpopLeftMenuList15 from '/data/landun/workspace/p-886b67fca2dd4cca8e715cc19519f511/src/src/pages/globalpedia/models/gpopLeftMenuList.ts';
import ModelMilestoneOperationVisible16 from '/data/landun/workspace/p-886b67fca2dd4cca8e715cc19519f511/src/src/pages/globalpedia/models/milestoneOperationVisible.ts';
import ModelStudioOverallTabId17 from '/data/landun/workspace/p-886b67fca2dd4cca8e715cc19519f511/src/src/pages/globalpedia/models/studioOverallTabId.ts';
import ModelSystemGuide18 from '/data/landun/workspace/p-886b67fca2dd4cca8e715cc19519f511/src/src/pages/globalpedia/models/systemGuide.ts';
import ModelTipsView19 from '/data/landun/workspace/p-886b67fca2dd4cca8e715cc19519f511/src/src/pages/globalpedia/models/tipsView.ts';
import ModelLocker20 from '/data/landun/workspace/p-886b67fca2dd4cca8e715cc19519f511/src/src/pages/globalpedia/pages/Pipeline/ChangeLog/components/ChangeChecklist/models/locker.ts';
import ModelLocker21 from '/data/landun/workspace/p-886b67fca2dd4cca8e715cc19519f511/src/src/pages/globalpedia/pages/Pipeline/ChangeLog/components/ChangeDetail/models/locker.ts';
import ModelLocker22 from '/data/landun/workspace/p-886b67fca2dd4cca8e715cc19519f511/src/src/pages/globalpedia/pages/Pipeline/GRActionItems/models/locker.ts';
import ModelLocker23 from '/data/landun/workspace/p-886b67fca2dd4cca8e715cc19519f511/src/src/pages/globalpedia/pages/Pipeline/Overview/components/Schedule/models/locker.ts';
import ModelLocker24 from '/data/landun/workspace/p-886b67fca2dd4cca8e715cc19519f511/src/src/pages/globalpedia/pages/Pipeline/Project/models/locker.ts';
import ModelLocker25 from '/data/landun/workspace/p-886b67fca2dd4cca8e715cc19519f511/src/src/pages/globalpedia/pages/StudioMonthlyReport/PerformanceOverview/models/locker.ts';
import ModelCronExpressions26 from '/data/landun/workspace/p-886b67fca2dd4cca8e715cc19519f511/src/src/pages/home/models/cronExpressions.ts';
import ModelGuide27 from '/data/landun/workspace/p-886b67fca2dd4cca8e715cc19519f511/src/src/pages/home/models/guide.ts';
import ModelHome28 from '/data/landun/workspace/p-886b67fca2dd4cca8e715cc19519f511/src/src/pages/home/models/home.ts';
import ModelReport29 from '/data/landun/workspace/p-886b67fca2dd4cca8e715cc19519f511/src/src/pages/home/models/report.ts';
import ModelSearch30 from '/data/landun/workspace/p-886b67fca2dd4cca8e715cc19519f511/src/src/pages/home/models/search.ts';
import ModelStudio31 from '/data/landun/workspace/p-886b67fca2dd4cca8e715cc19519f511/src/src/pages/home/models/studio.ts';
import ModelConfigureTexts32 from '/data/landun/workspace/p-886b67fca2dd4cca8e715cc19519f511/src/src/pages/intelligence/models/configureTexts.ts';
import ModelFilter33 from '/data/landun/workspace/p-886b67fca2dd4cca8e715cc19519f511/src/src/pages/intelligence/models/filter.ts';
import ModelFilterExtend34 from '/data/landun/workspace/p-886b67fca2dd4cca8e715cc19519f511/src/src/pages/intelligence/models/filterExtend.ts';
import ModelFilterInherit35 from '/data/landun/workspace/p-886b67fca2dd4cca8e715cc19519f511/src/src/pages/intelligence/models/filterInherit.ts';
import ModelFilterTimeHasData36 from '/data/landun/workspace/p-886b67fca2dd4cca8e715cc19519f511/src/src/pages/intelligence/models/filterTimeHasData.ts';
import ModelGlobalViewMarketAndGenre37 from '/data/landun/workspace/p-886b67fca2dd4cca8e715cc19519f511/src/src/pages/intelligence/models/globalViewMarketAndGenre.ts';
import ModelNewMarks38 from '/data/landun/workspace/p-886b67fca2dd4cca8e715cc19519f511/src/src/pages/intelligence/models/newMarks.ts';
import ModelOptions39 from '/data/landun/workspace/p-886b67fca2dd4cca8e715cc19519f511/src/src/pages/intelligence/models/options.ts';
import ModelPcConsoleCompare40 from '/data/landun/workspace/p-886b67fca2dd4cca8e715cc19519f511/src/src/pages/intelligence/models/pcConsoleCompare.ts';
import ModelStoreRankExtend41 from '/data/landun/workspace/p-886b67fca2dd4cca8e715cc19519f511/src/src/pages/intelligence/models/storeRankExtend.ts';
import ModelTopcharts42 from '/data/landun/workspace/p-886b67fca2dd4cca8e715cc19519f511/src/src/pages/intelligence/models/topcharts.ts';
import ModelIndex43 from '/data/landun/workspace/p-886b67fca2dd4cca8e715cc19519f511/src/src/pages/marketing/components/FilterCommon/models/filter/index.tsx';
import ModelIndex44 from '/data/landun/workspace/p-886b67fca2dd4cca8e715cc19519f511/src/src/pages/marketing/models/menu/index.tsx';
import ModelIndex45 from '/data/landun/workspace/p-886b67fca2dd4cca8e715cc19519f511/src/src/pages/opinion/models/common/index.tsx';
import ModelIndex46 from '/data/landun/workspace/p-886b67fca2dd4cca8e715cc19519f511/src/src/pages/opinion/models/commonLoading/index.tsx';
import ModelIndex47 from '/data/landun/workspace/p-886b67fca2dd4cca8e715cc19519f511/src/src/pages/opinion/models/feeds/index.tsx';
import ModelCond48 from '/data/landun/workspace/p-886b67fca2dd4cca8e715cc19519f511/src/src/pages/opinion/models/filter/cond.tsx';
import ModelFeeds49 from '/data/landun/workspace/p-886b67fca2dd4cca8e715cc19519f511/src/src/pages/opinion/models/filter/feeds.tsx';
import ModelIndex50 from '/data/landun/workspace/p-886b67fca2dd4cca8e715cc19519f511/src/src/pages/opinion/models/filter/index.tsx';
import ModelShortIdFilter51 from '/data/landun/workspace/p-886b67fca2dd4cca8e715cc19519f511/src/src/pages/opinion/models/filter/shortIdFilter.ts';
import ModelStore52 from '/data/landun/workspace/p-886b67fca2dd4cca8e715cc19519f511/src/src/pages/opinion/models/filter/store.tsx';
import ModelIndex53 from '/data/landun/workspace/p-886b67fca2dd4cca8e715cc19519f511/src/src/pages/opinion/models/game/index.tsx';
import ModelIndex54 from '/data/landun/workspace/p-886b67fca2dd4cca8e715cc19519f511/src/src/pages/opinion/models/intelligence/index.tsx';
import ModelIndex55 from '/data/landun/workspace/p-886b67fca2dd4cca8e715cc19519f511/src/src/pages/opinion/models/loading/index.tsx';
import ModelIndex56 from '/data/landun/workspace/p-886b67fca2dd4cca8e715cc19519f511/src/src/pages/opinion/models/menu/index.tsx';
import ModelIndex57 from '/data/landun/workspace/p-886b67fca2dd4cca8e715cc19519f511/src/src/pages/opinion/models/performance/index.tsx';
import ModelIndex58 from '/data/landun/workspace/p-886b67fca2dd4cca8e715cc19519f511/src/src/pages/opinion/models/store/index.tsx';
import ModelTipsView59 from '/data/landun/workspace/p-886b67fca2dd4cca8e715cc19519f511/src/src/pages/user-center/models/tipsView.ts';
import ModelModel60 from '/data/landun/workspace/p-886b67fca2dd4cca8e715cc19519f511/src/src/pages/aigc/pages/Text2SQL/model.ts';
import ModelModel61 from '/data/landun/workspace/p-886b67fca2dd4cca8e715cc19519f511/src/src/pages/datalab/pages/BehaviorAnalysis/ExplorationAnalysis/model.ts';
import ModelModel62 from '/data/landun/workspace/p-886b67fca2dd4cca8e715cc19519f511/src/src/pages/datalab/pages/Multidimensional/Analysis/model.ts';
import ModelModel63 from '/data/landun/workspace/p-886b67fca2dd4cca8e715cc19519f511/src/src/pages/datalab/pages/Multidimensional/Extraction/model.ts';
import ModelModel64 from '/data/landun/workspace/p-886b67fca2dd4cca8e715cc19519f511/src/src/pages/datalab/pages/Number/DataManagement/model.ts';

let app:any = null;

export function _onCreate(options = {}) {
  const runtimeDva = plugin.applyPlugins({
    key: 'dva',
    type: ApplyPluginsType.modify,
    initialValue: {},
  });
  app = dva({
    history,
    
    ...(runtimeDva.config || {}),
    // @ts-ignore
    ...(typeof window !== 'undefined' && window.g_useSSR ? { initialState: window.g_initialProps } : {}),
    ...(options || {}),
  });
  
  app.use(createLoading());
  (runtimeDva.plugins || []).forEach((plugin:any) => {
    app.use(plugin);
  });
  app.model({ namespace: 'benchmark', ...ModelBenchmark0 });
app.model({ namespace: 'dashboard', ...ModelDashboard1 });
app.model({ namespace: 'dashboardSetting', ...ModelDashboardSetting2 });
app.model({ namespace: 'engagement', ...ModelEngagement3 });
app.model({ namespace: 'monetization', ...ModelMonetization4 });
app.model({ namespace: 'overview', ...ModelOverview5 });
app.model({ namespace: 'rangePikerLeft', ...ModelRangePikerLeft6 });
app.model({ namespace: 'realtime', ...ModelRealtime7 });
app.model({ namespace: 'customDashboard.ts', ...ModelCustomDashboardTs8 });
app.model({ namespace: 'datalab', ...ModelDatalab9 });
app.model({ namespace: 'exploreAnalysisGames', ...ModelExploreAnalysisGames10 });
app.model({ namespace: 'privilegesConfig', ...ModelPrivilegesConfig11 });
app.model({ namespace: 'collapseableLogoList', ...ModelCollapseableLogoList12 });
app.model({ namespace: 'detailProgressTag', ...ModelDetailProgressTag13 });
app.model({ namespace: 'gameDetailTabData', ...ModelGameDetailTabData14 });
app.model({ namespace: 'gpopLeftMenuList', ...ModelGpopLeftMenuList15 });
app.model({ namespace: 'milestoneOperationVisible', ...ModelMilestoneOperationVisible16 });
app.model({ namespace: 'studioOverallTabId', ...ModelStudioOverallTabId17 });
app.model({ namespace: 'systemGuide', ...ModelSystemGuide18 });
app.model({ namespace: 'tipsView', ...ModelTipsView19 });
app.model({ namespace: 'locker', ...ModelLocker20 });
app.model({ namespace: 'locker', ...ModelLocker21 });
app.model({ namespace: 'locker', ...ModelLocker22 });
app.model({ namespace: 'locker', ...ModelLocker23 });
app.model({ namespace: 'locker', ...ModelLocker24 });
app.model({ namespace: 'locker', ...ModelLocker25 });
app.model({ namespace: 'cronExpressions', ...ModelCronExpressions26 });
app.model({ namespace: 'guide', ...ModelGuide27 });
app.model({ namespace: 'home', ...ModelHome28 });
app.model({ namespace: 'report', ...ModelReport29 });
app.model({ namespace: 'search', ...ModelSearch30 });
app.model({ namespace: 'studio', ...ModelStudio31 });
app.model({ namespace: 'configureTexts', ...ModelConfigureTexts32 });
app.model({ namespace: 'filter', ...ModelFilter33 });
app.model({ namespace: 'filterExtend', ...ModelFilterExtend34 });
app.model({ namespace: 'filterInherit', ...ModelFilterInherit35 });
app.model({ namespace: 'filterTimeHasData', ...ModelFilterTimeHasData36 });
app.model({ namespace: 'globalViewMarketAndGenre', ...ModelGlobalViewMarketAndGenre37 });
app.model({ namespace: 'newMarks', ...ModelNewMarks38 });
app.model({ namespace: 'options', ...ModelOptions39 });
app.model({ namespace: 'pcConsoleCompare', ...ModelPcConsoleCompare40 });
app.model({ namespace: 'storeRankExtend', ...ModelStoreRankExtend41 });
app.model({ namespace: 'topcharts', ...ModelTopcharts42 });
app.model({ namespace: 'index', ...ModelIndex43 });
app.model({ namespace: 'index', ...ModelIndex44 });
app.model({ namespace: 'index', ...ModelIndex45 });
app.model({ namespace: 'index', ...ModelIndex46 });
app.model({ namespace: 'index', ...ModelIndex47 });
app.model({ namespace: 'cond', ...ModelCond48 });
app.model({ namespace: 'feeds', ...ModelFeeds49 });
app.model({ namespace: 'index', ...ModelIndex50 });
app.model({ namespace: 'shortIdFilter', ...ModelShortIdFilter51 });
app.model({ namespace: 'store', ...ModelStore52 });
app.model({ namespace: 'index', ...ModelIndex53 });
app.model({ namespace: 'index', ...ModelIndex54 });
app.model({ namespace: 'index', ...ModelIndex55 });
app.model({ namespace: 'index', ...ModelIndex56 });
app.model({ namespace: 'index', ...ModelIndex57 });
app.model({ namespace: 'index', ...ModelIndex58 });
app.model({ namespace: 'tipsView', ...ModelTipsView59 });
app.model({ namespace: 'model', ...ModelModel60 });
app.model({ namespace: 'model', ...ModelModel61 });
app.model({ namespace: 'model', ...ModelModel62 });
app.model({ namespace: 'model', ...ModelModel63 });
app.model({ namespace: 'model', ...ModelModel64 });
  return app;
}

export function getApp() {
  return app;
}

/**
 * whether browser env
 * 
 * @returns boolean
 */
function isBrowser(): boolean {
  return typeof window !== 'undefined' &&
  typeof window.document !== 'undefined' &&
  typeof window.document.createElement !== 'undefined'
}

export class _DvaContainer extends Component {
  constructor(props: any) {
    super(props);
    // run only in client, avoid override server _onCreate()
    if (isBrowser()) {
      _onCreate()
    }
  }

  componentWillUnmount() {
    let app = getApp();
    app._models.forEach((model:any) => {
      app.unmodel(model.namespace);
    });
    app._models = [];
    try {
      // 释放 app，for gc
      // immer 场景 app 是 read-only 的，这里 try catch 一下
      app = null;
    } catch(e) {
      console.error(e);
    }
  }

  render() {
    let app = getApp();
    app.router(() => this.props.children);
    return app.start()();
  }
}
